import React from 'react';

export default function DoubleCard({ className = '', title }) {
  return (

    <svg
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={true}
      className={className}
    >
      <path
        d="M17.6562 0H5.46875C4.17641 0 3.125 1.05141 3.125 2.34375C3.125 2.77523 3.47477 3.125 3.90625 3.125C4.33773 3.125 4.6875 2.77523 4.6875 2.34375C4.6875 1.91297 5.03797 1.5625 5.46875 1.5625H17.6562C18.087 1.5625 18.4375 1.91297 18.4375 2.34375V10.1562C18.4375 10.587 18.087 10.9375 17.6562 10.9375H16.875V7.03125C16.875 5.73891 15.8236 4.6875 14.5312 4.6875H2.34375C1.05141 4.6875 0 5.73891 0 7.03125V14.8438C0 16.1361 1.05141 17.1875 2.34375 17.1875H14.5312C15.8236 17.1875 16.875 16.1361 16.875 14.8438V12.5H17.6562C18.9486 12.5 20 11.4486 20 10.1562V2.34375C20 1.05141 18.9486 0 17.6562 0ZM15.3125 14.8438C15.3125 15.2745 14.962 15.625 14.5312 15.625H2.34375C1.91297 15.625 1.5625 15.2745 1.5625 14.8438V7.03125C1.5625 6.60047 1.91297 6.25 2.34375 6.25H14.5312C14.962 6.25 15.3125 6.60047 15.3125 7.03125V7.8125H3.90625C3.47477 7.8125 3.125 8.16227 3.125 8.59375C3.125 9.02523 3.47477 9.375 3.90625 9.375H15.3125V14.8438Z"
        fill="currentColor"
      />
      <path
        d="M12.9688 14.0625H9.84375C9.41227 14.0625 9.0625 13.7127 9.0625 13.2812C9.0625 12.8498 9.41227 12.5 9.84375 12.5H12.9688C13.4002 12.5 13.75 12.8498 13.75 13.2812C13.75 13.7127 13.4002 14.0625 12.9688 14.0625Z"
        fill="currentColor"
      />
    </svg>

  );
}

